export const clampVolume = value => {
    if (value == null || value === '') return 0.5
    const number = Number(value)
    return Number.isFinite(number) && number >= 0 && number <= 1 ? number : 0.5
}

export const clampTime = (value, duration) => {
    const time = Number(value); const total = Number(duration)
    if (!Number.isFinite(time) || !Number.isFinite(total) || total <= 0) return 0
    return Math.min(total, Math.max(0, time))
}

export const progressPercent = (currentTime, duration) => {
    const total = Number(duration); const current = Number(currentTime)
    if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(current)) return 0
    return Math.min(100, Math.max(0, (current / total) * 100))
}

export const formatRadioTime = value => {
    const seconds = Number(value)
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00'
    const whole = Math.floor(seconds); const hours = Math.floor(whole / 3600)
    const minutes = Math.floor((whole % 3600) / 60); const remainder = whole % 60
    return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}` : `${minutes}:${String(remainder).padStart(2, '0')}`
}

export const resolveInitialTrackIndex = (tracks, storedId) => {
    if (!Array.isArray(tracks) || tracks.length === 0) return -1
    const index = tracks.findIndex(track => String(track.id) === String(storedId || ''))
    return index >= 0 ? index : 0
}

export const adjacentTrackIndex = (length, current, direction) => {
    if (!Number.isInteger(length) || length <= 0) return -1
    const start = Number.isInteger(current) && current >= 0 && current < length ? current : 0
    const step = direction === -1 ? -1 : 1
    return (start + step + length) % length
}

export const endedPlaybackAction = trackCount => {
    if (!Number.isInteger(trackCount) || trackCount <= 0) return 'none'
    return trackCount === 1 ? 'restart' : 'advance'
}

export const safeStorageGet = (key, fallback = null, getStorage = () => window.localStorage) => {
    try {
        const value = getStorage().getItem(key)
        return value == null ? fallback : value
    } catch { return fallback }
}

export const safeStorageSet = (key, value, getStorage = () => window.localStorage) => {
    try { getStorage().setItem(key, value); return true } catch { return false }
}

export const restoreCollapsed = value => value === 'true'

export const normalizePublicTracks = value => !Array.isArray(value) ? [] : value.slice(0, 10).flatMap(track => {
    if (!track || typeof track !== 'object' || !track.id || typeof track.title !== 'string' || typeof track.audioUrl !== 'string' || !track.audioUrl) return []
    return [{
        id: String(track.id), title: track.title, artist: typeof track.artist === 'string' ? track.artist : '',
        gameTitle: typeof track.gameTitle === 'string' ? track.gameTitle : '', audioUrl: track.audioUrl,
        coverImageUrl: typeof track.coverImageUrl === 'string' ? track.coverImageUrl : '',
        spotifyUrl: typeof track.spotifyUrl === 'string' ? track.spotifyUrl : ''
    }]
})

export const createRequestGate = () => {
    let latest = 0; let mounted = true
    return { begin: () => ++latest, isCurrent: id => mounted && id === latest, dispose: () => { mounted = false; latest += 1 }, resume: () => { mounted = true } }
}
